<template>
    <section class="kit-card">
        <div class="kit-card__image">
            <def-like
                v-if="getScreenSize() >= 768"
                :result="result"
            />
            <a :href="result?.detailPage">
                <DefImg :result="result?.picture || result?.morePhotos?.[0]" />
            </a>
        </div>
        <div class="kit-card__bottom">
            <p v-if="getScreenSize() >= 768 && price.printDiscountPercent" class="def-sale">
                    <span>{{ price.printDiscountPercent }}</span>
            </p>
            <a :href="result?.detailPage" class="kit-card__title">
                {{ result.type }}
            </a>
            <span v-if="activeSize" class="def-size">{{ messages.size }}: {{ activeSize?.displayValue }}</span>
            <div class="kit-card__prices">
                <span class="def-price">
                    {{ price.printPrice }}
                </span>
                <span
                    v-if="price.printPriceOld"
                    class="def-price-old"
                >
                    {{ price.printPriceOld }}
                </span>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';

import DefImg from '../../../def/DefImg/DefImg.vue';
export default {
    name: 'ProductKitsCard',
    props: ['result'],
    components: {
        DefImg,
    },
    computed: {
        ...mapState({
            messages: ({ product }) => product.data.messages,
        }),
        activeSize() {
            return this.result?.propsForCheck?.SIZES?.find(el => el.active);
        },
        price() {
            return this.result?.price;
        },
    },
    methods: {
        getScreenSize() {
            return window.innerWidth;
        }
    }
}
</script>

<style lang="scss">
.kit-card {
    display: flex;
    background-color: #fff;
    margin-bottom: 4px;
    position: relative;
    flex-shrink: 0;
    @include point-md {
        width: 236px;
        flex-direction: column;
        margin-right: 4px;
        margin-bottom: 0px;
    }
    @include point-lg {
        width: 324px;
    }

    &:after {
        content: '';
        width: 16px;
        height: 16px;
        background-color: var(--border-colour-primary);
        position: absolute;
        top: calc(100% + 2px);
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 3.5H7V4.25H1V3.5Z' fill='white'/%3E%3Cpath d='M3.5 7L3.5 1L4.25 1L4.25 7L3.5 7Z' fill='white'/%3E%3C/svg%3E%0A");
        @include point-md {
            top: 50%;
            right: 0;
            left: unset;
            transform: translate(50%, -50%);
            width: 32px;
            height: 32px;
            background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 7H14V8.5H2V7Z' fill='white'/%3E%3Cpath d='M7 14L7 2L8.5 2L8.5 14L7 14Z' fill='white'/%3E%3C/svg%3E%0A");
        }
    }

    &:last-of-type {
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 2.5H7V3.25H1V2.5Z' fill='white'/%3E%3Cpath d='M1 5H7V5.75H1V5Z' fill='white'/%3E%3C/svg%3E%0A");
            @include point-md {
                background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 5H14V6.5H2V5Z' fill='white'/%3E%3Cpath d='M2 10H14V11.5H2V10Z' fill='white'/%3E%3C/svg%3E");
            }
        }
    }

    &__image {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        max-width: 80px;
        padding: 10px;
        @include point-md {
            margin-bottom: 50px;
            max-width: unset;
            padding: 24px 24px 0;
        }

        :deep{
            .def-img {
                margin: 0 auto;
            }
        }

        a {
            display: block;
        }
    }

    &__bottom {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-weight: 500;
        font-size: rem(14);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        padding: 8px;
        @include point-md {
            text-align: center;
            font-size: rem(16);
            padding: 24px;
            justify-content: flex-start;
        }
    }

    &__title {
        display: block;
        margin-bottom: 2px;
    }

    &__prices {
        margin-top: 10px;
        @include point-md {
            margin-top: 18px;
        }
    }

    .def-price {
        font-weight: 400;
        font-size: rem(14);
        line-height: 110%;
        margin-right: 5px;
        color: #363636;
        @include point-md {
            font-size: rem(16);
        }
    }

    .def-price-old {
        color: #757575;
        font-size: rem(14);
        @include point-md {
            font-size: rem(16);
        }
    }

    .def-like {
        position: absolute;
        top: 17px;
        right: 17px;
    }
}
</style>